import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Lingue PUBBLICATE nel selettore e indicizzate.
// L'infrastruttura, i contenuti dati (site.en.js) e la chrome (navbar/footer) EN sono pronti:
// aggiungere "en" qui SOLO quando anche i testi inline di TUTTE le pagine saranno tradotti,
// per non pubblicare contenuti misti. Idem per "es".
export const SUPPORTED_LANGS = ["it"];
// Italiano unica lingua pubblicata e navigabile: /en/ e /es/ vengono reindirizzati
// a /it/ dal guard in Layout, così non risultano pubblicate né indicizzabili.
// L'infrastruttura EN (site.en.js, useContent, SEO) resta pronta per la FASE 2.
export const ROUTABLE_LANGS = ["it"];
export const DEFAULT_LANG = "it";

i18n.use(initReactI18next).init({
  // Non usiamo i18next per i testi (gestiti dai file di contenuto it/en),
  // ma per lo stato della lingua corrente e per il fallback.
  resources: { it: {}, en: {} },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: ROUTABLE_LANGS,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
